import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { FilterOption } from '../objects/SummaryObject';
import { forkJoin, Subject } from 'rxjs';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var SummaryService = /** @class */ (function () {
    function SummaryService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.enableSearch = new Subject();
        this.enableSearchChanged$ = this.enableSearch.asObservable();
        this.filter = new Subject();
        this.filterChanged$ = this.filter.asObservable();
        this.sort = new Subject();
        this.sortChanged$ = this.sort.asObservable();
        this.chartTable = new Subject();
        this.chartTableChanged$ = this.chartTable.asObservable();
        this.hasNewMessages = new Subject();
        this.hasNewMessagesChanged$ = this.hasNewMessages.asObservable();
        this.summaryUpdate = new Subject();
        this.summaryUpdateChanged$ = this.summaryUpdate.asObservable();
        this.loginUrl = this.env.servicePath;
        this.serviceUrl = this.env.servicePath;
    }
    SummaryService.prototype.setEnableSearch = function (search) {
        this.enableSearch.next(search);
    };
    SummaryService.prototype.setFilter = function (column) {
        this.filter.next(column);
    };
    SummaryService.prototype.setSort = function (column) {
        this.sort.next(column);
    };
    SummaryService.prototype.setChartTable = function (loading) {
        this.chartTable.next(loading);
    };
    SummaryService.prototype.setHasNewMessages = function (loading) {
        this.hasNewMessages.next(loading);
    };
    SummaryService.prototype.setSummaryUpdate = function (update) {
        this.summaryUpdate.next(update);
    };
    SummaryService.prototype.createSummary = function (type, summaryName) {
        var path = this.loginUrl + "GetNewSummary/" + type + "/" + summaryName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.getNewSummaryFromDetail = function (detailCardId, groupId, noRelation) {
        var path = this.loginUrl + "GetNewSummaryFromDetail/" + detailCardId + "/" + groupId + "?noRelation=" + noRelation;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.getDataSetSummaryFromDetail = function (detailCardId, propertyId) {
        var path = this.loginUrl + "GetDataSetSummaryFromDetail/" + detailCardId + "/" + propertyId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.getSummary = function (id) {
        var path = this.loginUrl + "GetSummaryCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions).timeout(20000);
    };
    SummaryService.prototype.getSummaryFilterOptions = function (id) {
        var path = this.loginUrl + "GetSummaryCardFilterOptions/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getSummaryDropdownList = function (id, summaryItemId, propertyName) {
        var path = this.loginUrl + "GetSummaryDropdownList/" + id + "/" + summaryItemId + "/" + propertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getSummaryFilterOptionList = function (id, fieldName) {
        var path = this.loginUrl + "GetSummaryCardFilterOptionList/" + id + "/" + fieldName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.changeFilter = function (id, filterChecked) {
        var path = this.loginUrl + "ChangeSummaryFilter/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, JSON.stringify(filterChecked), httpOptions);
    };
    SummaryService.prototype.applyFilters = function (id) {
        var path = this.loginUrl + "ApplySummaryFilter/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.getCurrentSort = function (id) {
        var path = this.loginUrl + "GetCurrentSort/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getCurrentSearchKeyword = function (id) {
        var path = this.loginUrl + "GetCurrentSearchTerm/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getSummarySortOptions = function (id) {
        var path = this.loginUrl + "GetSummaryCardSortOptions/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.createSummaryWithRelation = function (type, summaryName, relatedType, relatedId) {
        var path = this.loginUrl + "GetNewSummary/" + type + "/" + summaryName + "?relatedParentType=" + relatedType + "&relatedParentId=" + relatedId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.selectItem = function (id, selectedId) {
        var path = this.loginUrl + "SelectSummaryItem/" + id + "/" + selectedId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.selectItems = function (id, param) {
        var path = this.loginUrl + "SelectItems/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    SummaryService.prototype.previousPage = function (id) {
        var path = this.loginUrl + "SummaryPreviousPage/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.nextPage = function (id) {
        var path = this.loginUrl + "SummaryNextPage/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.changePage = function (id, selectedPage) {
        var path = this.loginUrl + "ChangeSummaryPage/" + id + "/" + selectedPage;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.searchKeyword = function (id, keyword) {
        var path = this.loginUrl + "SearchSummaryByKeyword/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, keyword, httpOptions);
    };
    SummaryService.prototype.searchAndReturnSummary = function (id, keyword) {
        var _this = this;
        var path = this.loginUrl + "SearchSummaryByKeyword/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, keyword, httpOptions).switchMap(function (result) {
            var path = _this.loginUrl + "GetSummaryCard/" + id;
            var httpOptions = {
                headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": _this.globals.Session.Session.UserId, "Session": _this.globals.Session.Session.SessionId })
            };
            return _this.http.get("" + path, httpOptions).timeout(20000);
        });
    };
    SummaryService.prototype.clearKeyword = function (id) {
        var path = this.loginUrl + "ClearSummaryKeyword/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.changeSortType = function (id, sortType) {
        var path = this.loginUrl + "ChangeSummaryOrderType/" + id + "/" + sortType;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.changeSortDirection = function (id, sortDirectionIsAscending) {
        var path = this.loginUrl + "ChangeSummaryOrderDirection/" + id + "/" + sortDirectionIsAscending;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.changePageSize = function (id, selectedSize) {
        var path = this.loginUrl + "ChangeSummaryPagingSize/" + id + "/" + selectedSize;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.downloadFile = function (attachmentId) {
        var path = this.loginUrl + "DownloadFile/" + attachmentId;
        var httpOptions = {
            responseType: 'blob',
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getImageData = function (attachmentId) {
        var path = this.loginUrl + "DownloadFile/" + attachmentId;
        var httpOptions = {
            responseType: 'blob',
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getAllImage = function (ids) {
        var getObs = [];
        for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
            var id = ids_1[_i];
            var path = this.loginUrl + "DownloadFile/" + id;
            var httpOptions = {
                responseType: 'blob',
                headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
            };
            getObs.push(this.http.get("" + path, httpOptions));
        }
        return forkJoin(getObs);
    };
    SummaryService.prototype.summaryItem = function (id, selectedId, param, actionName) {
        var path = this.loginUrl + "SummaryItemAction/" + id + "/" + selectedId + "/" + actionName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    SummaryService.prototype.summaryAction = function (id, param, actionName) {
        var path = this.loginUrl + "SummaryAction/" + id + "/" + actionName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    SummaryService.prototype.createSummaryPendingItems = function () {
        var path = this.serviceUrl + "CreatePendingItemsCard";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.selectSummaryPendingItems = function (id, type) {
        var path = this.serviceUrl + ("SelectPendingItem/" + id + "/" + type);
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.getSummaryPendingItems = function (id) {
        var path = this.serviceUrl + "GetPendingItemsCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getSelectedId = function (id) {
        var path = this.loginUrl + "GetSummarySelectedId/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.checkIfSummaryHasUpdate = function (id) {
        var path = this.loginUrl + "CheckIfSummaryHasUpdate/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.CheckSummaryTableSort = function (id) {
        var path = this.loginUrl + "CheckSummaryTableSortingByColumn/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.ChangeSummaryTableSorting = function (id, columnName) {
        var path = this.loginUrl + "ChangeSummaryTableSortingByColumn/" + id + "/" + columnName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.AddAdvancedSummaryFilter = function (id, param) {
        var path = this.loginUrl + "AddAdvancedSummaryFilter/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    SummaryService.prototype.RemoveAdvancedSummaryFilter = function (id, filterPropertyName) {
        var path = this.loginUrl + "RemoveAdvancedSummaryFilter/" + id + "/" + filterPropertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.ClearSummaryFilter = function (id) {
        var path = this.loginUrl + "ClearSummaryFilter/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.ClearAdvancedSummaryFilter = function (id) {
        var path = this.loginUrl + "ClearAdvancedSummaryFilter/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.CheckAdvancedSummaryFilter = function (id, filterPropertyName) {
        var path = this.loginUrl + "CheckAdvancedSummaryFilter/" + id + "/" + filterPropertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.FilterColumnByValue = function (id, columnName, search) {
        var path = this.loginUrl + "FilterColumnByValue/" + id + "/" + columnName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, search, httpOptions);
    };
    SummaryService.prototype.GetFilterColumnValue = function (id, columnName) {
        var path = this.loginUrl + "GetFilterColumnValue/" + id + "/" + columnName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.ClearColumnFilter = function (id) {
        var path = this.loginUrl + "ClearColumnFilter/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.UserSelectionInput = function (id, value) {
        var path = this.loginUrl + "UserSelectionInput/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, value, httpOptions);
    };
    SummaryService.prototype.changeSummaryLayout = function (id) {
        var path = this.loginUrl + "ChangeSummaryLayout/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.saveCurrentSummarySortLayout = function (id) {
        var path = this.loginUrl + "SaveCurrentSummarySortLayout/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.requestEmailSummary = function (id) {
        var path = this.loginUrl + "RequestEmailSummary/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.summaryFunction = function (id, action, data) {
        var path = this.loginUrl + "SummaryFunction/" + id + "/" + action;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, data, httpOptions);
    };
    SummaryService.prototype.getConfirmationMessage = function (id, selectedItemId, command) {
        var path = this.loginUrl + "GetConfirmationMessage/" + id + "/" + selectedItemId + "/" + command;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getSummaryFilterDropdownList = function (id, propertyName) {
        var path = this.loginUrl + "GetSummaryFilterDropdownList/" + id + "/" + propertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.checkItem = function (id, selectedItemId, body) {
        var path = this.loginUrl + "CheckItem/" + id + "/" + selectedItemId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, body, httpOptions);
    };
    SummaryService.prototype.uncheckItem = function (id, selectedItemId) {
        var path = this.loginUrl + "UncheckItem/" + id + "/" + selectedItemId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.changeRowValue = function (id, selectedItemId, body) {
        var path = this.loginUrl + "ChangeRowValue/" + id + "/" + selectedItemId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, body, httpOptions);
    };
    SummaryService.prototype.addNewRemark = function (id, body) {
        var path = this.loginUrl + "AddNewRemark/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, body, httpOptions);
    };
    SummaryService.prototype.getSummaryBreakdownFromSummary = function (selectedItem, docType, summaryName, docId) {
        var path = this.loginUrl + "GetSummaryBreakdownFromSummary/" + selectedItem + "/" + docType + "/" + summaryName + "?docId=" + docId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.getBasicSummary = function (docType, summaryName) {
        var path = this.loginUrl + "GetNewSummary/" + docType + "/" + summaryName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.checkAllItems = function (id) {
        var path = this.loginUrl + "CheckAllItems/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.uncheckAllItems = function (id) {
        var path = this.loginUrl + "UncheckAllItems/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    SummaryService.prototype.updateSummaryColumnState = function (id, data) {
        var path = this.loginUrl + "UpdateSummaryColumnState/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, data, httpOptions);
    };
    SummaryService.prototype.getSummaryColumnState = function (id) {
        var path = this.loginUrl + "GetSummaryColumnState/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.getFileReport = function (id, reportId) {
        var path = this.loginUrl + "GetFileReport/" + id + "/" + reportId;
        var httpOptions = {
            responseType: 'blob',
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    SummaryService.prototype.actionOnAllItem = function (id, param) {
        var path = this.loginUrl + "SummaryAllItemAction/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    SummaryService.ngInjectableDef = i0.defineInjectable({ factory: function SummaryService_Factory() { return new SummaryService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: SummaryService, providedIn: "root" });
    return SummaryService;
}());
export { SummaryService };
